import {IBaseResourceItem} from 'models/resources';

export const filterResourceCollectionById = (collection: IBaseResourceItem[], id: string) =>
  collection.filter((resource: IBaseResourceItem) => resource.contentItemId !== id);
